import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedLink } from "../../hooks/useLocalizedLink";

function DestinationOne() {
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();

  const destinations = [
    {
      id: 1,
      key: "tripleRoom",
      image: "/assets/img/2-3-kisilik/2-3-kisilik-dikey (4).jpeg",
      link: "/service/triple-room",
    },
    {
      id: 2,
      key: "diningHall",
      image: "/assets/img/yurt-fotograf/yemekhane/5.jpg",
      link: "/service/social-areas",
    },
    {
      id: 3,
      key: "terrace",
      image: "/assets/img/yurt-fotograf/teras/7.jpg",
      link: "/service/social-areas",
    },
    {
      id: 4,
      key: "studyRoom",
      image: "/assets/img/yurt-fotograf/etut/1.jpg",
      link: "/service/social-areas",
    },
    {
      id: 5,
      key: "exterior",
      image: "/assets/img/yurt-fotograf/dis-cephe/33.jpg",
      link: "/gallery",
    },
    {
      id: 6,
      key: "bathroom",
      image: "/assets/img/yurt-fotograf/banyo/24.jpg",
      link: "/gallery",
    },
    {
      id: 7,
      key: "singleRoom",
      image: "/assets/img/2-3-kisilik/2-3-kisilik-dikey (1).jpeg",
      link: "/service/single-room",
    },
    {
      id: 8,
      key: "doubleRoom",
      image: "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (1).jpeg",
      link: "/service/double-room",
    },
    {
      id: 9,
      key: "quadRoom",
      image: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/14.jpg",
      link: "/service/quad-room",
    },
    {
      id: 10,
      key: "sixRoom",
      image: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/17.jpg",
      link: "/service/six-room",
    },
  ];

  const sliderOptions = {
    modules: [EffectCoverflow],
    effect: "coverflow",
    centeredSlides: true,
    slidesPerView: "5",
    initialSlide: 0,
    grabCursor: true,
    loop: true, // Change from "true" to true
    speed: 1500,
    coverflowEffect: {
      rotate: 0,
      stretch: 95,
      depth: 212,
      modifier: 1,
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      576: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
      1200: { slidesPerView: 3 },
    },
  };

  const [cursorActive, setCursorActive] = useState(false);

  useEffect(() => {
    // Add event listeners for hover effect
    const sliderWrap = document.querySelector(".slider-drag-wrap");
    const sliderLink = document.querySelectorAll(".slider-drag-wrap a");

    const handleMouseEnter = () => setCursorActive(true);
    const handleMouseLeave = () => setCursorActive(false);

    if (sliderWrap) {
      sliderWrap.addEventListener("mouseenter", handleMouseEnter);
      sliderWrap.addEventListener("mouseleave", handleMouseLeave);
    }

    sliderLink.forEach((link) => {
      link.addEventListener("mouseenter", () => setCursorActive(false));
      link.addEventListener("mouseleave", () => setCursorActive(true));
    });

    // Clean up event listeners on component unmount
    return () => {
      if (sliderWrap) {
        sliderWrap.removeEventListener("mouseenter", handleMouseEnter);
        sliderWrap.removeEventListener("mouseleave", handleMouseLeave);
      }

      sliderLink.forEach((link) => {
        link.removeEventListener("mouseenter", () => setCursorActive(false));
        link.removeEventListener("mouseleave", () => setCursorActive(true));
      });
    };
  }, []);

  return (
    <div className="position-relative overflow-hidden">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">
            {t("home.popularDestinations.subTitle")}
          </span>
          <h2 className="sec-title">{t("home.popularDestinations.title")}</h2>
        </div>

        <div className={`slider-drag-wrap ${cursorActive ? "active" : ""}`}>
          <Swiper {...sliderOptions} className="destination-slider">
            {destinations.map((dest) => (
              <SwiperSlide key={dest.id}>
                <div className="destination-box gsap-cursor">
                  <div className="destination-img">
                    <img
                      src={dest.image}
                      alt={`Haseki Sultan Kız Öğrenci Yurdu - ${t(
                        `service.${dest.key}.title`
                      )}`}
                      title={`Haseki Sultan Kız Öğrenci Yurdu - ${t(
                        `service.${dest.key}.title`
                      )}`}
                    />
                    <div className="destination-content">
                      <div className="media-left">
                        <h4 className="box-title">
                          <Link to={getLocalizedPath(dest.link)}>
                            {t(`service.${dest.key}.title`)}
                          </Link>
                        </h4>
                      </div>
                      <div>
                        <Link
                          to={getLocalizedPath(dest.link)}
                          className="th-btn style2 th-icon"
                        >
                          {t("common.viewAll")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default DestinationOne;
